import {
  BOOKING_FORM_CBT_TRAVELERS_CLEAN_FIELDS,
  BOOKING_FORM_CBT_TRAVELERS_CLEAN_PASSPORT_FIELDS,
} from "../../lib/constants";
import { toArray } from "../../lib/functions";
import { getCleanFieldName } from "./getCleanFieldName";

function getTravelerPosition(form, travelerIndex) {
  const travelerField = form[`${travelerIndex}-traveler_firstname`];
  if (!travelerField) return null;

  const { room } = travelerField;
  if (!room) return null;

  const travelersInRoom = Object.keys(form)
    .filter((k) => k.endsWith("-traveler_firstname") && form[k].room === room)
    .map((k) => Number(k.split("-")[0]))
    .sort((a, b) => a - b);

  return travelersInRoom.indexOf(travelerIndex);
}

export function prefillCbtTravelers({
  fields,
  field,
  field: { name },
  cbtTravelersIds,
  cbt,
}): string {
  if (!getIsCbtTravelerField(name)) {
    return "";
  }

  const isHotel = !!fields?.["0-traveler_title"];

  const { cleanFieldName, travelerFieldIndex } = getCleanFieldName(name);

  const { usersCache } = cbt;

  if (isHotel && field?.name.includes("traveler")) {
    const nthInRoom = getTravelerPosition(
      fields,
      Number(field?.name?.split("-")[0])
    );

    const isTravelerInRoom = isHotel
      ? typeof field?.room === "string" &&
        field?.name.includes("traveler") &&
        cbt.passengersForm?.hotelRoomAssignmentsBookingProcess?.[
          field?.room?.split("-")[0]
        ]?.[nthInRoom] !== undefined
      : false;

    const isGuest =
      (!isHotel &&
        cbt?.passengersForm?.travellers &&
        name.split("-")[0] >= cbt.passengersForm.travellers.length) ||
      (isHotel && !isTravelerInRoom && field?.name.includes("traveler"));

    if (isGuest) {
      return "";
    }

    const cbtTravelerUser =
      usersCache[
        cbt?.passengersForm?.hotelRoomAssignmentsBookingProcess?.[
          field?.room?.split("-")[0]
        ]?.[nthInRoom]
      ];

    const travelerValue =
      cbtTravelerUser[BOOKING_FORM_CBT_TRAVELERS_CLEAN_FIELDS[cleanFieldName]];

    if (cleanFieldName === "title") {
      return travelerValue.toUpperCase();
    }

    return travelerValue;
  }

  const cbtTravelerUser =
    usersCache[toArray(cbtTravelersIds)[travelerFieldIndex]];

  if (!cbtTravelerUser) {
    return "";
  }

  if (
    BOOKING_FORM_CBT_TRAVELERS_CLEAN_PASSPORT_FIELDS[cleanFieldName] &&
    cbtTravelerUser.Passports.length > 0
  ) {
    return cbtTravelerUser.Passports[0][
      BOOKING_FORM_CBT_TRAVELERS_CLEAN_PASSPORT_FIELDS[cleanFieldName]
    ];
  }

  if (cleanFieldName === "title") {
    const titleValueFromCbtApi =
      cbtTravelerUser[BOOKING_FORM_CBT_TRAVELERS_CLEAN_FIELDS[cleanFieldName]];
    const selectedOption = field.options.find(
      (option) =>
        option.value.toLowerCase() === titleValueFromCbtApi.toLowerCase()
    );
    return selectedOption?.value || "";
  }

  if (
    cleanFieldName === "frequent_flyer" &&
    cbtTravelerUser?.FrequentFlyers?.length > 0
  ) {
    return getLoyaltyProgramsToPrefillCbt({
      currentFieldName: name,
      fields,
      userLoyaltyPrograms: cbtTravelerUser?.FrequentFlyers,
    }).loyaltyProgramId;
  }

  if (
    cleanFieldName === "frequent_flyer_number" &&
    cbtTravelerUser?.FrequentFlyers?.length > 0
  ) {
    return getLoyaltyProgramsToPrefillCbt({
      currentFieldName: name,
      fields,
      userLoyaltyPrograms: cbtTravelerUser?.FrequentFlyers,
    }).loyaltyProgramMembershipId;
  }

  return cbtTravelerUser[
    BOOKING_FORM_CBT_TRAVELERS_CLEAN_FIELDS[cleanFieldName]
  ];
}

function getIsCbtTravelerField(name): boolean {
  return (
    name.includes("-passenger_") ||
    name.includes("-traveler_") ||
    name.includes("DateOfBirth") ||
    name.includes("-traveller_")
  );
}

function getLoyaltyProgramsToPrefillCbt({
  currentFieldName,
  fields,
  userLoyaltyPrograms,
}) {
  const fieldWithFFOptionsName = currentFieldName.includes(
    "frequent_flyer_number"
  )
    ? currentFieldName.split("frequent_flyer_number").join("frequent_flyer")
    : currentFieldName;

  const availableLoyaltyPrograms =
    fields[fieldWithFFOptionsName]?.options || [];

  if (availableLoyaltyPrograms?.type === "codebook") {
    return {
      loyaltyProgramId: "",
      loyaltyProgramMembershipId: "",
    };
  }

  const loyaltyProgramToPrefill = userLoyaltyPrograms.find(
    (userLoyaltyProgram) =>
      availableLoyaltyPrograms.some(
        (availableLoyaltyProgram) =>
          availableLoyaltyProgram.value === userLoyaltyProgram.AirCompany
      )
  );

  return {
    loyaltyProgramId: loyaltyProgramToPrefill?.AirCompany || "",
    loyaltyProgramMembershipId: loyaltyProgramToPrefill?.Number || "",
  };
}
